import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'


Vue.use(VueRouter)


// 定义全局路由
const routes = [
  {
    path: '/login',
    name: '登陆',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: '首页', //图标样式
    component: Index,
  },
  {
    path: '/selectcollege',
    name: '智能填报',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Select_college.vue')
  },
  {
    path: '/querycollege',
    name: '高校信息',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Query_college.vue')
  },
  {
    path: '/scoresegment',
    name: '一分一段表',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Score_segment.vue')
  },
  {
    path: '/selectsubject',
    name: '新高考选科',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Select_subject.vue')
  },
  {
    path: '/register',
    name: '注册',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Register.vue')
  },
  {
    path: '/userinfo',
    name: '我的资料',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Userinfo.vue')
  },
  {
    path: '/questionanswer',
    name: '专家问答',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Question_answer.vue')
  },
  {
    path: '/myfavoritecollege',
    name: '我的志愿',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/My_favorite_college.vue')
  },
  {
    path: '/myfavoriteinformation',
    name: '我的志愿',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/My_favorite_information.vue')
  },
  {
    path: '/myquestion',
    name: '我的提问',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/My_question.vue')
  },
  {
    path: '/customerservice',
    name: '客户服务',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Customer_service.vue')
  },
  {
    path: '/preenroll',
    name: '提前批考栏',
    // 异步加载组件，解决首屏慢问题
    component: () => import('../views/Early_exam.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
